import ShowByRole from 'App/components/ShowByRole';
import { useGetPlanDebt } from 'domains/Auth/hooks';
import { PaymentStatusAlert } from 'domains/Billing/Checkout/components';
import { TransactionFeesPaymentAlert } from 'domains/Billing/TransactionFees/components';
import { KycRejectedAlert } from 'domains/NuvemPagoCommons/components/KycRejectedAlert';
import AlertFirstSale from '../AlertFirstSale';
import CardAuthenticationFactorPromotion from '../CardAuthenticationFactorPromotion';
import DomainDisconnectedAlert from '../DomainDisconnectedAlert';
import FacebookConnectionStatusAlert from '../FacebookConnectionStatusAlert';
import MercadoPagoCredentialsAlert from '../MercadoPagoCredentialsAlert';
import NuvemEnvioAdminBlockingAlert from '../NuvemEnvioAdminBlockingAlert';
import PagseguroCredentialsAlert from '../PaymentsNotifications/PagseguroCredentialsAlert';
import VerifyMercadoPagoAlert from '../PaymentsNotifications/VerifyMercadoPagoAlert';
import VerifyMercadoPagoSuccessOrDangerAlert from '../PaymentsNotifications/VerifyMercadoPagoSuccessOrDangerAlert';
import RecoveryCodesAlert from '../RecoveryCodesAlert';
import TrialMessages from '../TrialMessages';
import UpdateSuggestion from '../UpdateSuggestion';
import VulnerablePasswordAlert from '../VulnerablePasswordAlert';

function AlertNotifications() {
  const { shouldUseDebtData } = useGetPlanDebt(false);
  return (
    <>
      <RecoveryCodesAlert />
      <VulnerablePasswordAlert />
      <DomainDisconnectedAlert />
      <ShowByRole includeRoles="full">
        <>
          <KycRejectedAlert />
          <NuvemEnvioAdminBlockingAlert />
          <TrialMessages />
          <FacebookConnectionStatusAlert />
          <MercadoPagoCredentialsAlert />
          <VerifyMercadoPagoAlert />
          <VerifyMercadoPagoSuccessOrDangerAlert />
          <PagseguroCredentialsAlert />
          <UpdateSuggestion />
        </>
      </ShowByRole>
      <ShowByRole includeRoles="orders">
        <AlertFirstSale />
      </ShowByRole>
      <ShowByRole includeRoles="full">
        <>
          {!shouldUseDebtData && (
            <PaymentStatusAlert concept="plan-cost" isExternalContext />
          )}
          <TransactionFeesPaymentAlert initialFetch={false} />
        </>
      </ShowByRole>
      <CardAuthenticationFactorPromotion />
    </>
  );
}

export default AlertNotifications;
